import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { TipoEtapa } from '@/models';

@Injectable({
  providedIn: 'root'
})
export class TipoEtapaService {
  private apiUrl = `${environment.apiUrl}/admin/tipos-etapas`;

  constructor(private http: HttpClient) { }

  /**
   * Lista todos os tipos de etapas
   * @param apenasAtivos Se true, retorna apenas tipos ativos
   */
  getAll(apenasAtivos: boolean = true): Observable<TipoEtapa[]> {
    let params = new HttpParams();
    if (apenasAtivos) {
      params = params.set('apenasAtivos', apenasAtivos.toString());
    }

    return this.http.get<TipoEtapa[]>(this.apiUrl, { params });
  }

  /**
   * Busca tipo de etapa por ID
   * GET
   * /api/tipos-etapas/{id}
   * Buscar tipo de etapa por ID
   * @param id ID do tipo de etapa
   * @returns Observable<TipoEtapa | undefined>
   */
  getById(id: number): Observable<TipoEtapa | undefined> {
    return this.http.get<TipoEtapa>(`${this.apiUrl}/${id}`);
  }

  /**
   * Cria um novo tipo de etapa
   * POST
   * /api/tipos-etapas
   * Criar tipo de etapa
   * @param data Dados do tipo de etapa
   * @returns Observable<TipoEtapa>
   */
  create(data: TipoEtapa): Observable<TipoEtapa> {
    return this.http.post<TipoEtapa>(this.apiUrl, data);
  }

  /**
   * Atualiza um tipo de etapa existente
   * PUT
   * /api/tipos-etapas/{id}
   * Atualizar tipo de etapa
   * @param id ID do tipo de etapa
   * @param data Dados do tipo de etapa
   * @returns Observable<TipoEtapa>
   */
  update(id: number, data: TipoEtapa): Observable<TipoEtapa> {
    return this.http.put<TipoEtapa>(`${this.apiUrl}/${id}`, data);
  }

  /**
   * Ativa um tipo de etapa existente
   * PATCH
   * /api/tipos-etapas/{id}/toggle-status
   * Alternar status do tipo de etapa
   * @param id ID do tipo de etapa
   * @param active Status do tipo de etapa
   * @returns Observable<TipoEtapa>
   */
  toggleStatus(id: number, active: boolean): Observable<TipoEtapa> {
    return this.http.patch<TipoEtapa>(`${this.apiUrl}/${id}/toggle-status`, { active });
  }

  /**
   * Exclui um tipo de etapa existente
   * DELETE
   * /api/tipos-etapas/{id}
   * Excluir tipo de etapa
   * @param id ID do tipo de etapa
   * @returns Observable<TipoEtapa>
   */
  delete(id: number): Observable<TipoEtapa> {
    return this.http.delete<TipoEtapa>(`${this.apiUrl}/${id}`);
  }
}
